export const parseCurrentErrorCodes = currentErrorCodes => {
    if (Array.isArray(currentErrorCodes)) {
        return currentErrorCodes
            .filter(code => code != null && code !== '')
            .map(code => (typeof code === 'number' ? code : Number(code)))
            .filter(code => !Number.isNaN(code));
    }

    if (typeof currentErrorCodes === 'string') {
        return currentErrorCodes
            .split(',')
            .map(code => code.trim())
            .filter(Boolean)
            .map(Number)
            .filter(code => !Number.isNaN(code));
    }

    return [];
};

export const formatCurrentErrorCodes = currentErrorCodes => parseCurrentErrorCodes(currentErrorCodes).join(', ');
